// Full device headers
export const CompanyHeaders = {
  _id: {
    name: "Id",
    width: 1.7,
    textAlign: "left",
  },
  name: {
    name: "Company Name",
    width: 1.7,
    textAlign: "left",
  },
  industry: {
    name: "Industry",
    width: 1,
    textAlign: "left",
  },
  size: {
    name: "Size",
    width: 0.8,
    textAlign: "left",
  },
  status: {
    name: "Status",
    width: 0.6,
    textAlign: "center",
    justifyContent: "center",
  },
  website: {
    name: "Website",
    width: 1.2,
    textAlign: "left",
  },
  "": { name: "", width: 0.3, textAlign: "" },
  actions: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};

// Medium device headers - reduced columns
export const CompanyMediumDeviceHeaders = {
  _id: {
    name: "Id",
    width: 1.7,
    textAlign: "left",
  },
  name: {
    name: "Company Name",
    width: 1.7,
    textAlign: "left",
  },
  industry: {
    name: "Industry",
    width: 1,
    textAlign: "left",
  },
  status: {
    name: "Status",
    width: 0.8,
    textAlign: "center",
  },
  "": { name: "", width: 0.3, textAlign: "" },
  actions: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};

// Small device headers - minimal columns
export const CompanySmallDeviceHeaders = {
  name: {
    name: "Company",
    width: 1.5,
    textAlign: "left",
  },
  actions: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};
